import { CellContext } from '@tanstack/react-table'
import { useSelector } from 'react-redux'
import { selectUser } from '../../reducers/users'
import { Alert, AlertStatus } from '../../types/AlertTypes'
import { RoleType } from '../../types/UserTypes'
import { getRoles, permitsRole } from '../../utils/roles'

const AlertSelectionCell: React.FC<{
  row: CellContext<Alert, string>
  checkedItems: Record<number, boolean>
  setCheckedItems: (checkedItems: Record<number, boolean>) => void
  handleCheckboxChange: (id: number) => void
}> = ({ row, checkedItems, setCheckedItems, handleCheckboxChange }) => {
  const { session } = useSelector(selectUser)
  const roles = getRoles(session)

  if (permitsRole(roles, [RoleType.ACCESS_MGMT])) {
    return (
      <div className="ml-4 mt-1.5">
        <input
          key={row.row.original.id}
          id={'checked_alert_' + row.row.original.id}
          type="checkbox"
          className={`h-8 w-8 text-blue-600 rounded focus:ring-mainPurple checked:bg-mainPurple dark:bg-transparent dark:checked:bg-mainPurple scale-50 ${row.row.original.alertStatus === AlertStatus.CLOSED ? 'cursor-not-allowed bg-gray-50 dark:bg-neutral-11' : 'cursor-pointer border-gray-800 dark:border-gray-200'}`}
          disabled={row.row.original.alertStatus === AlertStatus.CLOSED}
          checked={(row.row.original.alertStatus === AlertStatus.OPEN && checkedItems[row.row.original.id]) || false}
          onChange={() => {
            setCheckedItems({
              ...checkedItems,
              [row.row.original.id]: !checkedItems[row.row.original.id],
            })
            handleCheckboxChange(row.row.original.id)
          }}
        />
      </div>
    )
  }

  return null
}

export default AlertSelectionCell
